//Could/should probably extend or directly use IEditableDataGridColumn or similar, this should do for now.
import { ReactNode } from 'react';
import { IEditableDataGridColumnDef } from '../@types/editableDataGridTypes';

export type ICustomColumnGetRowMetaData = (
  rowData: any,
  column: any
) => { attributeValues?: Array<any>; attributeConfig?: any; options?: ICustomColumn['options']; message?: string };

export type ICustomColumn = {
  name: string;
  fieldName: string | { fieldName: string };
  type: string;
  sortable?: boolean;
  idList?: Array<number>;
  //Below are just used on attribute columns (I.e. Not by free stock column config).
  objectType?: null;
  formatter?: ReactNode;
  options?:
    | { attributeConfig?: any; valuesPath?: string; isOldRecord?: boolean; decimals?: number }
    | IEditableDataGridColumnDef['options'];
  getRowMetaData?: ICustomColumnGetRowMetaData;
  editable?: boolean;
  overrides?: IEditableDataGridColumnDef;

  /**
   * If true, this column will always be displayed (It cannot be disabled via the column selector, but can be moved/re-sized).
   */
  required?: boolean;
};

interface INode {
  id?: number;
  [key: string]: any;
}

export interface IEdge {
  node: Node;
  [key: string]: any;
}

export type IColumnFromArrayDetailField = {
  title: string;
  fieldName: string;
  type?: 'String' | 'Boolean' | 'LocalDateTime' | 'Long' | 'LocalDate' | 'BigDecimal' | 'Int';
  options?: any;
  formatter?: string | ReactNode;
  overrides?: IEditableDataGridColumnDef;
};

/**
 * Note - Be careful with usage - Result must be memoised before passing through to useWorkspace.
 * (PriceList/Product effectively do this by only calling it from the 'onCompleted' functions of useQuery calls, rather than useMemo).
 */
export function setColumnsFromArray(
  fieldName: string,
  breakdownEntities: Array<INode | IEdge>,
  breakdownTitleField: string,
  detailFields: Array<IColumnFromArrayDetailField>,
  type: 'BigDecimal'
) {
  const customColumns: { [key: string]: ICustomColumn } = {};
  breakdownEntities.map((breakdown, index) => {
    const node = breakdown?.node || breakdown;
    const breakdownTitle = node[breakdownTitleField];

    //Don't include archived base records in the columns.
    if (node.archived) return;
    detailFields.forEach(({ fieldName: detailFieldName, type: detailType, title, options, formatter, overrides }) => {
      customColumns[`${fieldName}[${index}].${detailFieldName}`] = {
        name: `${title} - ${breakdownTitle}`,
        fieldName: `${fieldName}[${index}].${detailFieldName}`,
        sortable: false,
        type: detailType || type,
        idList: [node.id],
        options: options,
        formatter: formatter,
        overrides,
      };
    });
  });

  return customColumns;
}
